import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTable } from '@angular/material/table';
import { UntypedFormGroup } from '@angular/forms';
import { Filter } from '../../material';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { AfterViewInit, Inject, Injectable, OnDestroy, OnInit, Optional, Self} from '@angular/core';
import { A2filter } from '../../common';
import { A2TableDatasource, GenericDsService } from './a2-table-datasource';

@Injectable()
export abstract class A2TableBase<Doc> implements OnInit, AfterViewInit, OnDestroy {
  paginator: MatPaginator;
  sort: MatSort;
  table: MatTable<Doc>;
  protected componentDestroyed = new Subject();
  public dataSource: A2TableDatasource<Doc>;

  a2filter = new A2filter(this.filterForm);
  loading$;

  // protected service: Service;
  constructor(
    /**
     * the own DsService
     */
    @Self() protected dsService: GenericDsService<Doc>,
    /**
     * the qty of columns in the table
     */
    @Inject(Array) public displayedColumns:string[] = [],
    /**
     * Contains the group of the controls and those controls who use 'filters'
     */
    @Inject(UntypedFormGroup) public filterForm: UntypedFormGroup = new UntypedFormGroup({}),
    /**
     * where we have the filtering of a2mat-filters
     */
    @Inject(Array) public filters: Array<Filter> = [],


  ) {

  }

  ngOnInit(): void {
    this.OnInit();
   }
  ngAfterViewInit() {
    this.afterViewInit();
  }
  ngOnDestroy() {
    this.OnDestroy();
  }
  OnInit(){
    // this.dataSource = new A2TableDatasource<Doc>(this.dsService);
    if (this.dataSource.source  === 'elastic'){
      this.dsService.onChange().pipe(takeUntil(this.componentDestroyed))
      .subscribe( _ =>this.refresh());
    }
    this.dataSource.loading$.pipe(takeUntil(this.componentDestroyed))
    .subscribe((val) => this.loading$ = val);
  }
  afterViewInit(){
    this.dataSource.a2filter = this.a2filter;
    this.dataSource.sort = this.sort;
    this.dataSource.paginator = this.paginator;
    this.table.dataSource = this.dataSource;
  }
  OnDestroy(){
    this.componentDestroyed.next(true);
    this.componentDestroyed.unsubscribe();
  }
  refresh() {
    this.a2filter.refresh();
  }
  filterChange(filter:Filter){
    if(filter.selected){
      const op = filter.selected['op'] ?? '===';
      if (Array.isArray(filter.key)){
        filter.key.forEach(k =>{
          this.filterForm.controls[k].setValue(filter.selected.value[k]);
        })
      } else{
        // console.log("__",filter);
        this.filterForm.controls[filter.key].setValue(filter.selected.value);
      }
      this.a2filter.set(filter.key, op);
    } else{
      this.a2filter.unset(filter.key)
    }
  }


}

